{
  "name": "@byted/tiktok-zti-monitor",
  "version": "0.1.24",
  "unpkg": true,
  "unpkgFiles": [
    "*"
  ],
  "sideEffects": false,
  "jsnext:source": "./src/index.ts",
  "scripts": {
    "dev": "edenx dev",
    "build": "chmod +x build.sh && ./build.sh",
    "build:watch": "edenx build -w",
    "new": "edenx new",
    "upgrade": "edenx upgrade"
  },
  "dependencies": {
    "@byted/tiktok-zti-types": "workspace:*",
    "@dp/byted-tea-sdk-oversea": "5.2.4",
    "@slardar/integrations": "2.10.0"
  },
  "devDependencies": {
    "@byted/eslint-config-eden": "^5.0.21",
    "@edenx/module-tools": "1.48.4",
    "@slardar/web": "1.12.4",
    "eslint-plugin-prettier": "~4.2.1",
    "rimraf": "~3.0.2",
    "typescript": "~5.0.4"
  },
  "publishConfig": {
    "access": "public",
    "registry": "https://bnpm.byted.org/"
  },
  "main": "./dist/sg/lib/index.js",
  "types": "./dist/sg/types/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/sg/types/index.d.ts",
      "require": "./dist/sg/lib/index.js",
      "import": "./dist/sg/es/index.js",
      "default": "./dist/sg/lib/index.js"
    },
    "./sg": {
      "types": "./dist/sg/types/index.d.ts",
      "require": "./dist/sg/lib/index.js",
      "import": "./dist/sg/es/index.js",
      "default": "./dist/sg/lib/index.js"
    },
    "./va": {
      "types": "./dist/va/types/index.d.ts",
      "require": "./dist/va/lib/index.js",
      "import": "./dist/va/es/index.js",
      "default": "./dist/va/lib/index.js"
    },
    "./gcp": {
      "types": "./dist/gcp/types/index.d.ts",
      "require": "./dist/gcp/lib/index.js",
      "import": "./dist/gcp/es/index.js",
      "default": "./dist/gcp/lib/index.js"
    },
    "./eu": {
      "types": "./dist/gcp/types/index.d.ts",
      "require": "./dist/gcp/lib/index.js",
      "import": "./dist/gcp/es/index.js",
      "default": "./dist/gcp/lib/index.js"
    },
    "./oci": {
      "types": "./dist/oci/types/index.d.ts",
      "require": "./dist/oci/lib/index.js",
      "import": "./dist/oci/es/index.js",
      "default": "./dist/oci/lib/index.js"
    },
    "./pure": {
      "types": "./dist/pure/types/index.d.ts",
      "require": "./dist/pure/lib/index.js",
      "import": "./dist/pure/es/index.js",
      "default": "./dist/pure/lib/index.js"
    }
  }
}
